function positionContentInGrid() {
    var content = $('.content-tile')[0];

    if (content) {
        $(content).removeClass('content-in-grid');

        var contentData = $(content).data('contentTileAttributes');
        var contentPosition = contentData.position;
        var contentSize = contentData.slotSize;
        var contentOrientation = contentData.orientation;
        var browserSize = window.innerWidth;
        var gridTiles = $('.grid-tile');

        const SMALL_SCREEN_THRESHOLD = 590;
        const MEDIUM_SCREEN_THRESHOLD = 1205;

        function adjustPosition(position, divisor, numRows) {
            if (position % divisor === 0) position -= 1;
            return position;
        }

        function adjustPositionVH(position, divisor, numRows, isFourGridTiles = false) {
            if (contentPosition / divisor === numRows) position -= divisor;
            if (isFourGridTiles && position % divisor === 0) position -= 1;
            return position;
        }

        if (contentSize === 1) {
            $(content).addClass('grid-tile');
        } else if (contentSize === 2) {
            if (contentOrientation === 'horizontal') {
                $(content).addClass('grid-two-h-tiles');

                if (browserSize < SMALL_SCREEN_THRESHOLD) {
                    contentPosition = adjustPosition(contentPosition, 2, (gridTiles.length - 1) / 2);
                } else if (browserSize < MEDIUM_SCREEN_THRESHOLD) {
                    contentPosition = adjustPosition(contentPosition, 3, (gridTiles.length - 1) / 3);
                } else {
                    contentPosition = adjustPosition(contentPosition, 4, (gridTiles.length - 1) / 4);
                }
            } else if (contentOrientation === 'vertical') {
                $(content).addClass('grid-two-v-tiles');

                if (browserSize < SMALL_SCREEN_THRESHOLD) {
                    contentPosition = adjustPositionVH(contentPosition, 2, (gridTiles.length - 1) / 2);
                } else if (browserSize < MEDIUM_SCREEN_THRESHOLD) {
                    contentPosition = adjustPositionVH(contentPosition, 3, (gridTiles.length - 1) / 3);
                } else {
                    contentPosition = adjustPositionVH(contentPosition, 4, (gridTiles.length - 1) / 4);
                }
            }
        } else if (contentSize === 4) {
            $(content).addClass('grid-four-tiles');

            if (browserSize < SMALL_SCREEN_THRESHOLD) {
                contentPosition = adjustPositionVH(contentPosition, 2, (gridTiles.length - 1) / 2, true);
            } else if (browserSize < MEDIUM_SCREEN_THRESHOLD) {
                contentPosition = adjustPositionVH(contentPosition, 3, (gridTiles.length - 1) / 3, true);
            } else {
                contentPosition = adjustPositionVH(contentPosition, 4, (gridTiles.length - 1) / 4, true);
            }
        }

        gridTiles.splice(contentPosition - 1, 0, content);

        $('.grid-tile-container').html(gridTiles);
    }
}

$(document).ready(function () {
    positionContentInGrid();
    $(window).on('resize', positionContentInGrid);
});
